import { PageType } from "~/lib/router/enums";

export const pathname = "/posties/section-index";

export const page = {
  route(query: QueryParameters<{ entityId: string; name: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
};
